// Importaciones necesarias
import { useState, useEffect } from "react";
import ModalV2 from "../../../../components/ModalV2";
import InputParamField from "../components/InputParamField";
import { Button } from "@oc-labs/wt-storybook";
import useModal from "../../../../hooks/useModal";
import toast from "react-hot-toast";
import useCompany from "../../../../hooks/useCompany";
import useRwas from "../../../../hooks/useRwas";
import useMultimedia from "../../../../hooks/useMultimedia";

export default function NFTDataModal() {
  const { activeCompany: company } = useCompany();
  const { modal, close } = useModal("nft-data");
  const { updateRwaNfts } = useRwas();
  const { upload } = useMultimedia();
  const nftData = modal?.props;

  const [image, setImage] = useState("");
  const [text, setText] = useState("");

  const metadata = Object.keys(nftData || {}).length === 0 ? {} :
  nftData?.rwa_nft_data.reduce((acc, item) => {
    acc[item.key] = {
      value: item.value,
      fieldType: item.fieldType,
    }
    return acc;
  }, {});

  useEffect(() => {
    if (nftData) {
      setImage(metadata?.image?.value || "");
      setText(metadata?.description?.value || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nftData]);

  const handleSave = async () => {
    const updates = [];

    if (image !== (metadata?.image?.value || "")) {
      updates.push({
        key: "image",
        value: image,
        fieldType: "image",
      });
    }

    if (text !== (metadata?.description?.value || "")) {
      updates.push({
        key: "description",
        value: text,
        fieldType: "longtext",
      });
    }

    if (updates.length === 0) {
      toast("No changes to save");
      return;
    }

    try {
      for (const update of updates) {
        let finalValue = update.value;
        
        if (update.fieldType === "image" && update.value) {
          // Si es un File, subir la imagen primero
          if (update.value instanceof File) {
            finalValue = await upload(update.value);
          }
        }
        
        await updateRwaNfts(
          company.id,
          nftData.rwaId,
          nftData.id,
          {
            key: update.key,
            value: finalValue,
            fieldType: update.fieldType,
          }
        );
      }
      
      toast.success("NFT data updated successfully");
      close();
    } catch (err) {
      toast.error("Failed to update NFT data");
      console.error(err);
    }
  };

  const imageIsFile = image && typeof image === "object" && image instanceof File;
  const imageUrl = imageIsFile ? URL.createObjectURL(image) : image;


  return (
    <ModalV2 name="nft-data" className="w-[500px]" title="Edit NFT Attributes">
      <div className="space-y-4 px-4 py-2">
        <InputParamField
          base64={false}
          type="image"
          keyName="image"
          value={imageUrl}
          onChange={setImage}
        />

        <InputParamField
          type="longtext"
          keyName="text"
          value={text}
          onChange={setText}
        />

        <div className="flex justify-end pt-4 gap-2">
          <Button type="secondary" size="small" onClick={close}>
            Cancel
          </Button>

          <Button
            type="primary"
            size="small"
            onClick={handleSave}
          >
            Save
          </Button>
        </div>
      </div>
    </ModalV2>
  );
}
